import React from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import VendorSuccessImg from 'assets/images/vendor-success.webp';
import { BUSINESS_ROUTE } from 'data/global';

import './VendorSuccess.styles.scss';
import './VendorSuccess.styles.responsive.scss';

type VendorSuccessProps = {
  className?: string;
};

const VendorSuccess: React.FC<VendorSuccessProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();

  const classes = classNames('vendor-success', className);

  return (
    <div className={classes}>
      <ResolveImage src={VendorSuccessImg} />
      <h1>{t('vendorSuccessTitle')}</h1>
      <p>{t('vendorSuccessSubtitle')}</p>
      <Link
        to={BUSINESS_ROUTE}
        className="ncoded-button ncoded-button--solid"
        replace
      >
        {t('browseListings')}
      </Link>
    </div>
  );
};

export default VendorSuccess;
